module.exports = __webpack_public_path__ + "img/easter_tour_2.7f735fc2.png";